import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Pages
import Login from '../components/Dashboard/Views/Pages/Auth/Login.vue'
import Support from '../components/Dashboard/Views/Pages/Support.vue'

// User
import UserProfile from '../components/Dashboard/Views/Pages/UserProfile.vue'
// import TestEmail from '../components/Dashboard/Views/Pages/TesteEmail.vue'
// import TestEmailManager from '../components/Dashboard/Views/Pages/TesteEmailManager.vue'
import UserProfileEdit from '../components/Dashboard/Views/Pages/UserProfile/EditProfileForm.vue'
import PowerUniversity from '../components/Dashboard/Views/Pages/PowerUniversity.vue'

// Evaluation
import EvaluationAbout from '../components/Dashboard/Views/Pages/Evaluation/About.vue'
import EvaluationOverview from '../components/Dashboard/Views/Pages/Evaluation/Overview.vue'
import EvaluationList from '../components/Dashboard/Views/Pages/Evaluation/List.vue'
import EvaluationCode from '../components/Dashboard/Views/Pages/Evaluation/Code.vue'
import EvaluationPosition from '../components/Dashboard/Views/Pages/Evaluation/Position.vue'

// Evaluation - Manager
import EvaluationTeamList from '../components/Dashboard/Views/Pages/Manager/Evaluation/Team/List.vue'
import EvaluationTeamView from '../components/Dashboard/Views/Pages/Manager/Evaluation/Team/View.vue'
import EvaluationTeamOverview from '../components/Dashboard/Views/Pages/Manager/Evaluation/Team/Overview.vue'
import EvaluationTeamForm from '../components/Dashboard/Views/Pages/Manager/Evaluation/Form.vue'
import EvaluationTeamFormEdit from '../components/Dashboard/Views/Pages/Manager/Evaluation/FormEdit.vue'
import EvaluationFormResult from '../components/Dashboard/Views/Pages/Manager/Evaluation/FormResult.vue'

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

let supportPage = {
  path: '/suporte',
  name: 'Suporte',
  component: Support
}

let profilePage = {
  path: '/perfil',
  name: 'Perfil',
  component: UserProfile
}

// let testEmailPage = {
//   path: '/teste-email',
//   name: 'Teste de Email',
//   component: TestEmail
// }

// let testEmailManagerPage = {
//   path: '/teste-email-manager',
//   name: 'Teste de Email Gerente',
//   component: TestEmailManager
// }

let profileEditPage = {
  path: '/editar-perfil',
  name: 'Editar Perfil',
  component: UserProfileEdit
}

let evaluationPage = {
  path: '/sobre',
  name: 'Sobre',
  component: EvaluationAbout
}

let powerUniversityPage = {
  path: '/power-university',
  name: 'Power University',
  component: PowerUniversity,
  meta: {
    requiresAccessPowerUniversity: true,
    requiresManager: true
  }
}

let evaluationListPage = {
  path: 'listar',
  name: 'Minhas Avaliações',
  component: EvaluationList
}

let evaluationCodePage = {
  path: 'codigos',
  name: 'Códigos de Validação',
  component: EvaluationCode
}

let evaluationPositionPage = {
  path: 'descritivo',
  name: 'Descritivo de Função',
  component: EvaluationPosition
}

let evaluationOverviewPage = {
  path: 'resultado/:evaluationId',
  name: 'Visão geral da Avaliação',
  component: EvaluationOverview
}

// Manager
let evaluationTeamListPage = {
  path: 'equipe',
  name: 'Minha Equipe',
  component: EvaluationTeamList,
  meta: {
    requiresManager: true
  }
}

let evaluationTeamViewPage = {
  path: 'equipe/perfil/:collaboratorId',
  name: 'Perfil do Colaborador',
  component: EvaluationTeamView,
  meta: {
    requiresManager: true
  }
}

let evaluationTeamOverviewPage = {
  path: 'equipe/perfil/:collaboratorId/resultado-completo/:evaluationId',
  name: 'Visão Geral',
  component: EvaluationTeamOverview,
  meta: {
    requiresManager: true
  }
}

let evaluationTeamFormPage = {
  path: 'formulario/:collaboratorId/:evaluationId/:token',
  name: 'Formulário de Avaliação',
  component: EvaluationTeamForm,
  meta: {
    requiresManager: false
  }
}

let evaluationTeamFormEditPage = {
  path: 'formulario-editar/:evaluationId/:collaboratorId',
  name: 'Formulário de Av. - Edição',
  component: EvaluationTeamFormEdit,
  meta: {
    requiresManager: true
  }
}

let evaluationFormResultPage = {
  path: 'formulario-resultado/:evaluationId/:collaboratorId',
  name: 'Resultado da Avaliação',
  component: EvaluationFormResult,
  meta: {
    requiresManager: true
  }
}

let evaluation = {
  path: '/avaliacao',
  redirect: '/sobre',
  component: DashboardLayout,
  children: [
    // evaluationPage,
    evaluationOverviewPage,
    evaluationListPage,
    evaluationCodePage,
    // evaluationPositionPage,
    evaluationTeamListPage,
    evaluationTeamViewPage,
    evaluationTeamOverviewPage,
    evaluationTeamFormPage,
    evaluationTeamFormEditPage,
    evaluationFormResultPage
  ],
  meta: {
    requiresAuth: true
  }
}

const routes = [
  loginPage,
  supportPage,
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/perfil',
    children: [
      profilePage,
      profileEditPage,
      powerUniversityPage
    ],
    meta: {
      requiresAuth: true
    }
  },
  evaluation,
  // testEmailPage,
  // testEmailManagerPage,
  {path: '*', component: NotFound}
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js